import moment from "moment";

function twoDatesRelative(start_time, end_time, base_time) {
    var start_moment = moment(start_time);
    var end_moment = moment(end_time);
    var base_moment = moment(base_time);


    if (start_moment.isSame(end_moment, 'day')) {
        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('hh:mm a') + ' - ' + end_moment.format('hh:mm a ddd Do MMM');
        }
        else {
            return start_moment.format('hh:mm a') + ' - ' + end_moment.format('hh:mm a ddd Do MMM YYYY');;
        }
    }
    else if (start_moment.isSame(end_moment, 'month')) {

        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('hh:mm a ddd Do') + ' - ' + end_moment.format('hh:mm a ddd Do MMM');
        }
        else {
            return start_moment.format('hh:mm a ddd Do') + ' - ' + end_moment.format('hh:mm a ddd Do MMM YYYY');
        }
    }
    else {
        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('hh:mm a ddd Do MMM') + ' - ' + end_moment.format('hh:mm a ddd Do MMM');
        }
        else {
            return start_moment.format('hh:mm a ddd Do MMM') + ' - ' + end_moment.format('hh:mm a ddd Do MMM YYYY');
        }
    }
}

export {twoDatesRelative};

export default { twoDatesRelative }